'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var inner = {
  width: '100%',
  height: '100%',
  position: 'relative',
  overflow: 'hidden',
  transform: 'translate3d(0, 0, 0)',
  lineHeight: 0
};
var title = {
  fontSize: 0,
  height: 0,
  left: 0,
  overflow: 'hidden',
  position: 'absolute',
  top: 0,
  visibility: 'hidden',
  width: 0
};
exports.inner = inner;
exports.title = title;